module.exports = __webpack_public_path__ + "img/logo.b4cfdf84.svg";